import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

interface TileStyledProps {
  selected: boolean;
}
export const LegendStyled = styled(Box).attrs({
  pb: { sm: '300' },
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
})`
  width: 100px;
`;
export const StatsColorStyled = styled(Box)`
  width: 12px;
  height: 12px;
  ${({ theme, color }) => css`
    background-color: ${color};
    border-radius: ${theme.radii[900]};
  `}
`;
export const TileStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  ml: { sm: '400' },
  justifyContent: { sm: 'center' },
  alignSelf: { sm: 'center' },
  pl: { sm: '450' },
  pr: { sm: '450' },
})<TileStyledProps>`
  ${({ theme, selected }) => css`
    border: ${selected ? `1px solid ${theme.colors.blue[500]}` : ''};
    cursor: pointer;
    height: 60px;
    border-radius: ${theme.radii[300]};
    background-color: ${selected ? theme.colors.blue[100] : theme.colors.white};
    padding-top: ${selected ? theme.spacings[300] : theme.spacings[200]};
    padding-bottom: ${selected ? theme.spacings[300] : theme.spacings[200]};
    &:last-child {
      color: ${theme.colors.red[700]};
    }
    &:hover {
      box-shadow: ${theme.componentStyles.boxShadow};
    }
  `}
`;
